
angular.module('dybStudentAmc', ['classy', 'classy.computed', 'dyb.util.forms',
                                 'classy.models']);
